import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
// import "./barChartBox.scss";

type Props = {
  title: string;
  color: string;
  dataKey: string;
  chartData: object[];
};

const StackedBarChartBox = (props: Props) => {
  // console.log(props)
  return (
    <div className="w-full h-full ">
      <h1 className="mb-5">{props.title}</h1>
      <div className="">
        <ResponsiveContainer width="100%" height={200}>
            <BarChart
                data={props.chartData}
                // width={500}
                // height={300}
                // margin={{
                //     top: 20,
                //     right: 30,
                //     left: 20,
                //     bottom: 5,
                // }}
            >
                <CartesianGrid stroke="#716e6e" strokeDasharray="3 3" />
                <XAxis dataKey={props.xaxisKey} stroke="#f1eaea" 
                  tick={{ fill: '#ffffff' }} tickLine={{ stroke: '#688394' }}
                  axisLine={{ stroke: '#EAF0F4' }} 
                  style={{
                    fontSize: '10px',
                    // fontFamily: 'Times New Roman',
                  }}
                />
                <YAxis stroke="#f1eaea" 
                  tick={{ fill: '#ffffff' }} tickLine={{ stroke: '#688394' }}
                  axisLine={{ stroke: '#EAF0F4' }} 
                  style={{
                    fontSize: '10px',
                    // fontFamily: 'Times New Roman',
                  }}
                />
            <Tooltip
              contentStyle={{ background: "#2a3447", borderRadius: "5px" }}
              // labelStyle={{ display: "none" }}
              cursor={{fill:"none"}}
            />
                <Legend />
                <Bar dataKey={props.yaxisKey1} label={props.chartData?.Cash} stackId="a" fill="#8884d8"   />
                <Bar dataKey={props.yaxisKey2}  label={props.chartData?.ScanQR} stackId="a" fill="#82ca9d"  />
            </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default StackedBarChartBox;
